import store from '@/store';
import { ref } from '@vue/composition-api';
import Vue from 'vue';

export default function useLinkedTransaction() {
  const transaction = ref(null);
  const isLoading = ref(false);

  const tableColumns = [
    { text: 'ID', value: 'id', sortable: false },
    { text: 'Amount', value: 'amount', sortable: false },
    { text: 'Transaction ID', value: 'transactionId', sortable: false },
    { text: 'ARN', value: 'arn', sortable: false },
    { text: 'Created At', value: 'createdAt', sortable: false },
    { text: 'Actions', value: 'actions', align: 'center', sortable: false },
  ];

  const fetchTransactionById = (transactionId) => {
    isLoading.value = true;
    return store
      .dispatch('chargebackPreventionTransaction/fetchById', { id: transactionId })
      .then(async (response) => {
        transaction.value = response.data ;
        isLoading.value = false;
      })
      .catch(() => {
        Vue.notify({
          type: 'error',
          title: 'Prevent',
          text: 'Cannot fetch linked transaction.',
        });
      })
      .finally(() => (isLoading.value = false));
  };

  return {
    isLoading,
    transaction,
    tableColumns,
    fetchTransactionById,
  };
}
